import { render } from "./fornecedorForm.vue?vue&type=template&id=c72dcf2c&scoped=true"
import script from "./fornecedorForm.vue?vue&type=script&lang=js"
export * from "./fornecedorForm.vue?vue&type=script&lang=js"

import "./fornecedorForm.vue?vue&type=style&index=0&id=c72dcf2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72dcf2c"]])

export default __exports__